import {TextAnchorProperty} from 'csstype';

import {StrandOfDoubleStranded} from 'constants/MolbioConstants';
import {GRAY_LIGHT} from 'ui-library/Colors';
import {Point} from 'util/geometry/GeometryConstants';

export const DEFAULT_WIDTH = 150;
export const DEFAULT_HEIGHT = 110;
export const CIRCLE_CENTER = {x: 75, y: 55};
export const RADIUS = 25;
const LINEAR_CENTER_Y = 55;
const LINEAR_PADDING_X = 25;
const LINEAR_LENGTH = 100;
export const LINEAR_LEFT_POINT = {x: LINEAR_PADDING_X, y: LINEAR_CENTER_Y};
export const LINEAR_RIGHT_POINT = {x: LINEAR_LEFT_POINT.x + LINEAR_LENGTH, y: LINEAR_CENTER_Y};
export const BASE_STROKE_WIDTH = 3;
export const FRAGMENT_STROKE_WIDTH = 4;
export const PRIMER_STROKE_WIDTH = 2;
export const TEXT_HEIGHT = 13;
export const BASE_STROKE_COLOR = GRAY_LIGHT;

export interface TextPointInfo {
  anchor: TextAnchorProperty;
  point: Point;
}

export interface DisplayInfo {
  enzymeId: number | null;
  bases: string | null;
  primer?: boolean;
}

export interface VisualizationSequenceSummary {
  start: number;
  end: number | null;
  sequenceLength: number;
  strand: StrandOfDoubleStranded;
  circular: boolean;
  fivePrimeDisplayInfo: DisplayInfo;
  threePrimeDisplayInfo: DisplayInfo;
}
